<template>
    <div id="root">
        Hi there from Vue Component
        <div id="textZone">
            <input type="text" id="textInput">
        </div>
    </div>


</template>

<script>
  export default {
    mounted() {
      this.doSomethingWhenLoaded();
      this.doSomethingWhenLoaded();
    },

    methods: {
      doSomethingWhenLoaded() {
        console.log("componente pronto")
      }
    }

  }
</script>

